import { NextPage } from 'next'
import { ReactElement } from 'react'

import { ErrorPage as ErrPage } from '~/components/pages'

interface PageProps {
	statusCode: number
}

const ErrorPage: NextPage<PageProps> = (props: PageProps): ReactElement => {
	return <ErrPage errorStatus={props.statusCode} />
}

ErrorPage.getInitialProps = async ({ res, err }): Promise<PageProps> => {
	// Determine error status code
	return { statusCode: res?.statusCode || err?.statusCode || 500 }
}

export default ErrorPage
